export default __webpack_public_path__ + "generic_book_cover.e00653f5.jpg";